import { render } from "./PageBikouTable.vue?vue&type=template&id=2bf86f4b&scoped=true"
import script from "./PageBikouTable.vue?vue&type=script&lang=js"
export * from "./PageBikouTable.vue?vue&type=script&lang=js"

import "./PageBikouTable.vue?vue&type=style&index=0&id=2bf86f4b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf86f4b"]])

export default __exports__